/**
 * Tap action of the home modal. The contract, the whitelist of app screens and the checks
 * live in app-action.ts, shared with the banner carousel; this file keeps the names the
 * «Modal Home App» tab uses.
 */
import {
    AppAction,
    AppActionType,
    AppInternalRoute,
    APP_INTERNAL_ROUTES,
    describeAppTap,
    findAppInternalRoute,
    toAppActionType,
    validateAppAction,
} from './app-action';

export type HomeModalActionType = AppActionType;
export type HomeModalAction = AppAction;
export type HomeModalInternalRoute = AppInternalRoute;

/** App screens the home modal can open. */
export const HOME_MODAL_INTERNAL_ROUTES: readonly HomeModalInternalRoute[] = APP_INTERNAL_ROUTES;

export const toHomeModalActionType = toAppActionType;
export const findHomeModalInternalRoute = findAppInternalRoute;

/** Inline error for a draft action; empty when it can be published. */
export function validateHomeModalAction(action: HomeModalAction): string {
    return validateAppAction(action, 'la imagen');
}

/** Hint shown next to the preview describing what a tap does. */
export const describeHomeModalTap = describeAppTap;
